import React, {Component, Fragment} from 'react';
import Breadcrumb from '../../../../containers/navs/Breadcrumb';
import {Card, CardBody, Col, Row} from 'reactstrap';
import {Colxx, Separator} from '../../../../components/common/CustomBootstrap';
import {downloadFile, fixedToWithoutRound, numberWithCommas, selectStyles} from '../../../../helpers/Utils';
import {reactTableText} from '../../../../constants/configs';
import LoaderButton from '../../../../components/LoaderButton';
import IconCard from '../../../../components/cards/IconCard';
import ToolTip from '../../../../components/ToolTip';
import {withTranslation} from 'react-i18next';
import {store} from '../../../../AppRenderer';
import Api from '../../../../services/Api';
import {Link} from 'react-router-dom';
import ReactTable from 'react-table';
import Select from 'react-select';

class List extends Component {
  constructor(props) {
    super(props);
    this.state = {
      data: null,
      loading: false,
      submitting: false,
      selectedToken: null,
    };

    this.tokenOptions = store.getState().general.tokens.map(token => ({
      label: `${token.localeName} ${token.symbol}`, value: token.symbol
    }));
  }

  fetchData = async () => {
    const {selectedToken} = this.state;
    try {
      const {data} = await Api.invoke('GET', `/admin-ui/user-assets/${selectedToken}`);
      this.setState({
        data,
        loading: false,
      });
    } catch (e) {
      console.log('fetch user assets report error: ', e);
    }
  };

  getColumns = () => {
    const {t} = this.props;
    return [
      {
        Header: t('First Name'),
        accessor: 'firstName',
      },
      {
        Header: t('Last Name'),
        accessor: 'lastName',
      },
      {
        Header: t('Email'),
        accessor: 'email',
        width: 260,
      },
      {
        Header: t('National Code'),
        accessor: 'ssn',
        width: 120,
      },
      {
        Header: t('Phone Number'),
        accessor: 'phoneNumber',
        width: 120,
      },
      {
        Header: t('Balance'),
        accessor: 'amount',
        Cell: props => <span className="font-weight-semibold text-primary">{numberWithCommas(props.value)}</span>
      },
      {
        Header: t('Toman Value'),
        accessor: 'amountTMN',
        Cell: props => <span className="font-weight-semibold text-primary">{fixedToWithoutRound(props.value, 0)}</span>
      },
      {
        Header: t('Tether Value'),
        accessor: 'amountUsdt',
        Cell: props => <span className="font-weight-semibold text-primary">{fixedToWithoutRound(props.value, 2)}</span>
      },
      {
        Header: '',
        accessor: 'ref_id',
        width: 30,
        Cell: props => (
          <ToolTip id={`view_${props.value}`} text={t('View Profile')}>
            <Link to={{
              pathname: '/dashboard/users/' + props.value,
              state: {...props.original},
            }}>
              <i className="simple-icon-eye view-icon text-large"/>
            </Link>
          </ToolTip>
        ),
      }
    ];
  };

  onChangeToken = selected => {
    this.setState({
      data: null,
      loading: true,
      selectedToken: selected.value,
    }, this.fetchData);
  };

  downloadOutput = async () => {
    const {selectedToken} = this.state;
    this.setState({
      submitting: true,
    });
    try {
      const {data} = await Api.invoke(
        'GET',
        `/admin-ui/user-assets-download/${selectedToken}`,
        null,
        {
          cancelToken: null,
        },
      );
      downloadFile(data.url);
    } catch (e) {
      console.log('download user assets report error: ', e);
    } finally {
      this.setState({
        submitting: false,
      });
    }
  };

  render() {
    const {t, match} = this.props;
    const {data, selectedToken, loading, submitting} = this.state;
    return (
      <Fragment>
        <Row>
          <Colxx xxs="12">
            <Breadcrumb match={match}/>
            <Separator className="mb-4"/>
          </Colxx>
        </Row>
        <Select
          className="w-30"
          styles={selectStyles}
          placeholder={t('Select Token')}
          value={this.tokenOptions.find(option => option.value === selectedToken)}
          onChange={this.onChangeToken}
          options={this.tokenOptions}
        />
        {!loading && !!data &&
          <Row className="mt-4">
            <Colxx xxs="12" className="mb-4">
              <Card className="h-100">
                <CardBody>
                  <div>
                    <Row className="mb-4">
                      <Col className='col-12 col-md-6 col-lg-3'>
                        <IconCard
                          icon="icon-Business-Mens"
                          title={t('Users Count')}
                          value={numberWithCommas(data.totalUser)}
                        />
                      </Col>
                      <Col className='col-12 col-md-6 col-lg-3'>
                        <IconCard
                          icon="icon-Coins"
                          title={t('Total Balance')}
                          value={numberWithCommas(data.totalAmount)}
                        />
                      </Col>
                      <Col className='col-12 col-md-6 col-lg-3'>
                        <IconCard
                          icon="icon-Money-2"
                          title={t('Total Toman Value')}
                          value={fixedToWithoutRound(data.totalAmountTMN, 0)}
                        />
                      </Col>
                      <Col className='col-12 col-md-6 col-lg-3'>
                        <IconCard
                          icon="icon-Money-2"
                          title={t('Total Tether Value')}
                          value={fixedToWithoutRound(data.totalAmountUsdt, 2)}
                        />
                      </Col>
                    </Row>
                    {data.users.length > 0 && (
                      <div className="mt-10">
                        <div className="d-flex flex-row justify-content-between align-items-center mb-4">
                          <div className="text-large text-primary">
                            {t('List of {{symbol}} token holders', {symbol: selectedToken})}
                          </div>
                          <LoaderButton
                            color="success"
                            loading={submitting}
                            onClick={this.downloadOutput}
                            className="text-center">
                            {t('Download Excel File')}
                          </LoaderButton>
                        </div>
                        <ReactTable
                          ref={el => {this.table = el;}}
                          className="-highlight"
                          data={data.users}
                          sortable={false}
                          resizable={true}
                          showPagination={true}
                          columns={this.getColumns(t)}
                          defaultPageSize={25}
                          style={{
                            width: '100%'
                          }}
                          {...reactTableText}
                        />
                      </div>
                    )}
                  </div>
                </CardBody>
              </Card>
            </Colxx>
          </Row>
        }
        {loading && (
          <div className="d-flex flex-row align-items-center justify-content-center" style={{ height: 400 }}>
            <div className="loading-spinner" />
          </div>
        )}
      </Fragment>
    );
  }
}

export default withTranslation()(List);
